export default "__VITE_ASSET__XQb7Ol93__"